export class ScpAuditPreviousTableModel{
    columns:string[];
    rows:any[];

    constructor(){}
}